import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {IndicationReducer} from './store';
import {IndicationEffects} from './store/indication-effects';
import {IndicationContainerComponent} from './container/indication-container.component';
import {IndicationListComponent} from './components/indication-list/indication-list.component';
import {CommonModule} from '@angular/common';
import {IndicationItemComponent} from './components/indication-item/indication-item.component';

const routes: Routes = [
    {path: '', component: IndicationContainerComponent}
];
@NgModule({
    imports: [
        RouterModule.forChild(routes),
        StoreModule.forFeature(IndicationReducer.REDUCER_NAME, IndicationReducer.indicationReducer),
        EffectsModule.forFeature([IndicationEffects]),
        CommonModule
    ],
    exports: [
        IndicationContainerComponent,
        IndicationListComponent
    ],
    declarations: [
        IndicationContainerComponent,
        IndicationListComponent,
        IndicationItemComponent
    ]
})
export class IndicationsModule {
}
